import { useDispatch } from "react-redux";

export default () => useDispatch<any>()